import React from "react";
import LinkWithLabel from "@/components/detailsComponent/LinkWithLabel";
import DownloadIconLink from "@/components/detailsComponent/downloadIconLink";

export const DownloadView = props => {
  const { pdpLabelName, documentList, productName } = props;

  return (
    <>
      <p className="text-[14px] my-[10px]">{pdpLabelName}</p>
      <ul className="inline-flex mb-1">
        {documentList?.map((el, id) => (
          <>
            {el.ResourceFullWebURL ? (
              <>
                <DownloadIconLink url={el.ResourceFullWebURL} />
                <li key={el?.ResourceName || id}>
                  <LinkWithLabel
                    label={productName[el.ResourceType]}
                    url={el.ResourceFullWebURL}
                    className={`font-helveticaGroup font-light text-[14px] pr-2 uppercase ${
                      id !== documentList.length - 1 && `border-r border-black`
                    }`}
                  />
                </li>
              </>
            ) : null}
          </>
        ))}
      </ul>
    </>
  );
};
